












































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import poa_capitulos_conacs from '@/mixins/axios/poa_capitulos_conacs'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
        show:true,
        columnasd:[
            
            {
                tag:'clave',
                data:'clave',
                active:true
            },
             {
                tag:'capitulo',
                data:'capitulo',
                active:true
            },
            /* {
                tag:'color',
                data:'color',
                active:true
            },*/
         
        ],



        id:null as any,
     clave:'' as any,
     capitulo:'' as any,
    // color:'',
         
         
              poa_cap_conacdata:[] as any,
      
    }
  },
     mixins: [poa_capitulos_conacs],
     validations: {
    
           clave: {
      required,
    }, capitulo: {
      required,
    },
   
   
  },
  methods:{
       
      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_POA_CAP_CONACS(row).then(response => {

                    if (response != null) {
this.show=false;
 this.poa_cap_conacdata=this.poa_cap_conacdata.filter(item => item.id !== row.id);
 this.show=true;
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
  /*     select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPMD',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/pmd/ejes')
//this.getDataDepartamentos();

      
     },*/
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
     
        // this.color=1;
 this.clave=null;
      this.capitulo=null;  
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_otrosGastos').modal('show')
      },
seteditar(row){

 this.id=row.id;
this.clave=row.clave;
    this.capitulo=row.capitulo;        
         // this.color=row.color;
 $('#ac_modal_otrosGastos').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_POA_CAP_CONACS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.poa_cap_conacdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Tipo de Gastos, refresque la pagina");

                    }    $("#ac_modal_otrosGastos").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_POA_CAP_CONACS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Capitulos CONAC modificado exitosamente, refresque la pagina");
  this.poa_cap_conacdata=this.poa_cap_conacdata.filter(item => item.id !== dat.id);
 this.poa_cap_conacdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear pmd, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
 
         //color:'amaeillo',
           clave:this.clave,
               capitulo:this.capitulo,
            idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_POA_CAP_CONACS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_cap_conacdata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

